import React from 'react';
import { Helmet } from 'react-helmet-async';
import './FlowLayout.css';
import './Confirmation.css';

function Confirmed() {
  return (
    <div className="flow-page">
      <Helmet>
        <title>Registration Confirmed</title>
        <meta name="description" content="You have successfully joined Easy Global Entry. Start receiving interview notifications immediately." />
      </Helmet>

      {/* Progress Bar — Complete */}
      <div className="progress-bar-container" style={{ margin: '16px 0 16px' }} role="progressbar" aria-valuenow={3} aria-valuemin={1} aria-valuemax={3} aria-label="Step 3 of 3: Confirmed">
        <div className="progress-bar-header">
          <div></div>
          <div className="progress-bar-label">Step 3 of 3: Confirmed</div>
        </div>
        <div className="progress-bar-track">
          <div className="progress-bar-fill" style={{ width: '100%' }} />
        </div>
      </div>

      {/* Split layout */}
      <div className="flow-layout" style={{ gap: '40px' }}>
        {/* Left column — white card */}
        <div className="flow-left">
          <div className="confirm-left-card">
            <div className="confirm-check">
              <svg viewBox="0 0 24 24" fill="none" stroke="#2E8540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <h1 className="confirm-heading">
              You're all set! We'll notify you as soon as a slot opens.
            </h1>

            <h3 className="confirm-section-title">What happens next?</h3>
            <ul className="confirm-list">
              <li>Our systems are now monitoring your selected enrollment centers 24/7.</li>
              <li>The moment a new appointment slot is released, we will send an instant alert to your email.</li>
              <li>These alerts include a direct link to the booking portal so you can claim the slot before anyone else.</li>
              <li>You can unsubscribe or change your locations at any time using the link in our emails.</li>
            </ul>
          </div>
        </div>

        {/* Right column */}
        <div className="flow-right">
          <div className="confirm-right-card">
            <div className="confirm-status">
              <div className="confirm-status__dot" style={{ background: '#2E8540' }}></div>
              <p className="confirm-status__text" style={{ color: '#2E8540' }}>Alerts Active</p>
            </div>
            
            <div className="confirm-right-divider"></div>
            
            <p className="confirm-right-address" style={{ fontSize: '0.9rem', color: '#64748b' }}>
              We've sent a confirmation email to your inbox. Please check it to ensure you receive our future alerts.
            </p>

            <div style={{ marginTop: '32px' }}>
              <button 
                className="flow-btn-primary" 
                style={{ width: '100%' }}
                onClick={() => window.location.href = '/'}
              >
                Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirmed;
